import { handleError } from "../common/ErrorUtil";

import { executeGraphql, executeGraphqlLoop } from "./BaseApi";
import { updateDiagnosticChartDataDaily } from "./graphql/mutations";
import {
  getDiagnosticChartDataDaily,
  listDiagnosticChartDataDailies,
} from "./graphql/queries";

/**
 * 判定結果入力済み日付一覧取得APIの実行.
 *
 * @param {string} office 拠点名
 * @return {object} レスポンス
 */
export async function executeListJudgedDates(office) {
  const params = {
    office,
    date: { ge: "0" },
    filter: { creationResult: { eq: true } },
    sortDirection: "DESC",
    nextToken: null,
  };

  const key = "listDiagnosticChartDataDailies";
  const { data, error } = await executeGraphqlLoop(
    listDiagnosticChartDataDailies,
    params,
    key
  ).catch(handleError);

  const response = { error };
  if (data && data[key] && data[key].items) {
    response.data = {
      judgedDates: data[key].items.map((item) => item.date),
    };
  } else {
    response.data = {
      judgedDates: [],
    };
  }

  return response;
}

/**
 * 診断カルテデータ(前回/前々回)取得APIの実行.
 *
 * @param {string} office 拠点名
 * @param {string} date 日付
 * @return {object} レスポンス
 */
export async function executeGetReferenceDiagnosticChartDataDaily(
  office,
  date
) {
  const params = {
    office,
    date: { le: date },
    filter: { creationResult: { eq: true } },
    sortDirection: "DESC",
    limt: 1,
    nextToken: null,
  };

  const key = "listDiagnosticChartDataDailies";
  const { data, error } = await executeGraphqlLoop(
    listDiagnosticChartDataDailies,
    params,
    key
  ).catch(handleError);

  const response = { error };
  if (data && data[key] && data[key].items) {
    response.data = {
      diagnosticChartDataDaily: data[key].items.shift(),
    };
  } else {
    response.data = {
      diagnosticChartDataDaily: {},
    };
  }

  return response;
}

/**
 * 診断カルテデータ取得APIの実行.
 *
 * @param {string} office 拠点名
 * @param {string} date 日付
 * @return {object} レスポンス
 */
export async function executeGetDiagnosticChartDataDaily(office, date) {
  const params = {
    office,
    date,
  };
  const { data, error } = await executeGraphql(
    getDiagnosticChartDataDaily,
    params
  ).catch(handleError);

  const key = "getDiagnosticChartDataDaily";
  const response = { error };
  if (data && data[key]) {
    response.data = {
      diagnosticChartDataDaily: data[key],
    };
  } else {
    response.data = {
      diagnosticChartDataDaily: {},
    };
  }

  return response;
}

/**
 * 診断カルテデータ更新APIの実行.
 *
 * @param {object} payload 更新情報
 * @return {object} レスポンス
 */
export async function executeUpdateDiagnosticChartDataDaily(payload) {
  const params = {
    input: { ...payload },
  };

  const { data, error } = await executeGraphql(
    updateDiagnosticChartDataDaily,
    params
  ).catch(handleError);

  const key = "updateDiagnosticChartDataDaily";
  const response = { error };
  if (data && data[key]) {
    response.data = {
      diagnosticChartDataDaily: data[key],
    };
  } else {
    response.data = {
      diagnosticChartDataDaily: {},
    };
  }

  return response;
}
